<template>
  <div class="NavigationLinksTree">
    <a
      v-if="!hasChildren"
      :style="indent"
      class="NavigationLinksTree__link"
      @click="navigate"
    >{{ node.item.name[selectedLanguage] }}</a>
    <a
      v-if="hasChildren"
      :style="indent"
      class="NavigationLinksTree__link"
      @click="toggleChildren"
    >
      {{ node.item.name[selectedLanguage] }}
      <i
        v-show="!showChildren"
        class="fas fa-angle-down"
      />
      <i
        v-show="showChildren"
        class="fas fa-angle-up"
      />
    </a>
    <div
      v-if="showChildren"
      style="margin-top: 5px;"
    >
      <NavigationLinksTree
        v-for="(item, index) in node.item.children"
        :key="`item-${index}`"
        :node="item"
        :depth="depth + 1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationLinksTree',
  props: {
    node: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showChildren: false,
    };
  },
  computed: {
    selectedLanguage() {
      return this.$i18n.locale();
    },
    indent() {
      return { transform: `translate(${this.depth * 10}px)` };
    },
    hasChildren() {
      return this.node.item.children.length > 0;
    },
    navigationDrawerIsVisible() {
      return this.$store.state.layout.navigationDrawerIsVisible;
    },
  },
  watch: {
    navigationDrawerIsVisible(value) {
      if (!value) {
        this.showChildren = false;
      }
    },
  },
  methods: {
    navigate() {
      if (this.node.item.content_id) {
        this.$router.push({ name: 'topic', params: { id: this.node.item.content_id } });
      } else if (this.node.item.url) {
        window.location.href = `https://${this.node.item.url}`;
      }
    },
    toggleChildren() {
      this.showChildren = !this.showChildren;
    },
  },
};
</script>

<style scoped lang="scss">
.NavigationLinksTree__link {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
  display: inline-flex;
  align-items: center;
  text-transform: capitalize;
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 5px;

  &[href]:hover {
    color: lighten(#000, 40%);
  }

  i {
    margin-left: 10px;
    color: rgba(0,0,0,0.7);
    font-size: 12px;
  }
}
@include media-md() {
  .NavigationLinksTree__link {
    font-size: 16px;
  }
}
</style>
